import React, { useState, useEffect } from "react";
import axios from "axios";

import Header from "./Header2";
import "./Research_highlight_from.css";

const Research_highlight_from = () => {
  const xURL = "https://research.rihes.cmu.ac.th/api/";

  const [activeTab, setActiveTab] = useState(0);
  const [researcherData, setResearcherData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getCenter = tabId => {
    const centerMap = {
      0: 2,
      1: 1,
      2: 4
    };
    return centerMap[tabId] || tabId;
  };

  const reorderData = (data, tabId) => {
    const newData = [...data];

    if (tabId === 0 && newData.length > 13) {
      // Tab 0: เอา index 13 มาเป็นตัวแรก
      const item = newData.splice(13, 1)[0];
      newData.unshift(item);
    } else if (tabId === 1 && newData.length > 6) {
      // Tab 1: เอา index 6 มาอยู่ที่ index 2 (ตำแหน่งที่ 4)
      const item = newData.splice(6, 1)[0];
      newData.splice(3, 0, item);
    }
    // Tab 2: ไม่เปลี่ยน

    return newData;
  };

  const fetchResearcherHighlight = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${xURL}getResearch_rihes_hightlight`, {
        center: getCenter(activeTab)
      });
      if (response.data && response.data.length > 0) {
        setResearcherData(reorderData(response.data, activeTab));
      } else {
        setResearcherData([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  // เรียก API เมื่อ activeTab เปลี่ยน
  useEffect(
    () => {
      fetchResearcherHighlight();
    },
    [activeTab]
  );

  const tabs = [
    {
      id: 0,
      label: "ศูนย์วิจัยวิทยาศาสตร์สุขภาพ"
    },
    {
      id: 1,
      label: "ศูนย์วิจัยทางคลินิกและนวัตกรรมสุขภาพ"
    },
    {
      id: 2,
      label: "สำนักวิชาการวิจัยวิทยาศาสตร์สุขภาพ"
    }
  ];

  const getUnitByTabAndIndex = (tabId, idx) => {
    if (tabId === 0) {
      if (idx === 0)
        return "หัวหน้าศูนย์วิจัยวิทยาศาสตร์สุขภาพ / หน่วยวิจัยโรคติดเชื้อและชีววิทยาศาสตร์โมเลกุล";
      if (idx >= 1 && idx <= 9)
        return "หน่วยวิจัยอนามัยสิ่งแวดล้อมและอาชีวอนามัย";
      if (idx >= 10 && idx <= 13) return "หน่วยวิจัยพฤติกรรมสุขภาพ";
      if (idx >= 14 && idx <= 18)
        return "หน่วยวิจัยโรคติดเชื้อและชีววิทยาศาสตร์โมเลกุล";
      if (idx >= 19 && idx <= 23) return "หน่วยวิจัยโรคไม่ติดต่อเรื้อรัง";
      if (idx >= 24 && idx <= 27) return "หน่วยวิจัยและทดสอบทางโภชนาการ";
      if (idx >= 28 && idx <= 30) return "หน่วยวิจัยสารเสพติด";
    } else if (tabId === 1) {
      if (idx === 0) return "หัวหน้าศูนย์วิจัยทางคลินิกและนวัตกรรมสุขภาพ/แพทย์";
      if (idx >= 1 && idx <= 2) return "นักวิจัยอาวุโส";
      if (idx >= 3 && idx <= 7) return "แพทย์";
    } else if (tabId === 2) {
      if (idx === 0) return "หัวหน้าสำนักวิชาการวิจัยวิทยาศาสตร์สุขภาพ";
      if (idx === 1) return "รองหัวหน้าสำนักวิชาการวิจัยวิทยาศาสตร์สุขภาพ";
      if (idx >= 2 && idx <= 10) return "อาจารย์";
    }
    return ""; // ค่า fallback แทน row.unit
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editFormData, setEditFormData] = useState({
    topic_name_th: "",
    topic_name_eng: "",
    topic_detail_th: "",
    topic_detail_eng: "",
    topic_pic1_old: null,
    topic_pic1_preview: null,
    topic_pic1_file: null,
    topic_pic2_old: null,
    topic_pic2_preview: null,
    topic_pic2_file: null
  });

  const handleEditClick = row => {
    //  console.log("Row data:", row);
    setEditingRow(row);
    setEditFormData({
      topic_name_th: row.topic_name_th || "",
      topic_name_eng: row.topic_name_eng || "",
      topic_detail_th: row.topic_detail_th || "",
      topic_detail_eng: row.topic_detail_eng || "",
      topic_pic1_old: row.topic_pic1 || null,
      topic_pic1_preview: null,
      topic_pic1_file: null,
      topic_pic2_old: row.topic_pic2 || null,
      topic_pic2_preview: null,
      topic_pic2_file: null
    });
    setIsEditModalOpen(true);
  };

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        setEditFormData({
          ...editFormData,
          [`${fieldName}_preview`]: event.target.result, // preview รูปใหม่
          [`${fieldName}_file`]: file
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveEdit = async () => {
    try {
      let pic1Filename = editFormData.topic_pic1_old;
      let pic2Filename = editFormData.topic_pic2_old;

      if (editFormData.topic_pic1_file) {
        const pic1FormData = new FormData();
        pic1FormData.append("file", editFormData.topic_pic1_file);
        const pic1Response = await axios.post(
          `${xURL}uploadPic_Research_topic`,
          pic1FormData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        pic1Filename = pic1Response.data.filename;
      }

      if (editFormData.topic_pic2_file) {
        const pic2FormData = new FormData();
        pic2FormData.append("file", editFormData.topic_pic2_file);
        const pic2Response = await axios.post(
          `${xURL}uploadPic_Research_topic`,
          pic2FormData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        pic2Filename = pic2Response.data.filename;
      }

      const response = await axios.post(`${xURL}updateResearchHighlight`, {
        id: editingRow.id,
        topic_name_th: editFormData.topic_name_th,
        topic_name_eng: editFormData.topic_name_eng,
        topic_detail_th: editFormData.topic_detail_th,
        topic_detail_eng: editFormData.topic_detail_eng,
        topic_pic1: pic1Filename,
        topic_pic2: pic2Filename
      });

      if (response.data) {
        setIsEditModalOpen(false);
        fetchResearcherHighlight();
      }
    } catch (err) {
      console.error("Error updating data:", err);
      alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล: " + err.message);
    }
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
    setEditingRow(null);
  };

  const [enlargedImage, setEnlargedImage] = useState(null);

  return (
    <div className="research-highlight-page">
      <Header />

      <div className="research-highlight-container">
        <div className="research-title">
          <h1>Research Highlight</h1>
          <div className="research-content-line" />
        </div>

        <div className="tabs-container">
          <div className="tabs-header">
            {tabs.map(tab =>
              <button
                key={tab.id}
                className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            )}
          </div>

          <div className="tabs-content">
            {tabs[activeTab] &&
              <div className="tab-panel">
                <h2>
                  {tabs[activeTab].label}
                </h2>

                {loading
                  ? <div style={{ textAlign: "center", padding: "20px" }}>
                      กำลังโหลด...
                    </div>
                  : error
                    ? <div
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "red"
                        }}
                      >
                        {error}
                      </div>
                    : <div className="table-wrapper">
                        <table className="research-table">
                          <thead>
                            <tr>
                              <th width="5%">ลำดับ</th>
                              <th width="15%">ชื่อ</th>
                              <th width="25%">หน่วย/สังกัด</th>
                              <th width="5%" style={{ textAlign: "center" }}>
                                รูปโปรไฟล์
                              </th>
                              <th width="25%">หัวข้อวิจัยที่โดดเด่น</th>
                              <th width="5%" style={{ textAlign: "center" }}>
                                highlight pic 1
                              </th>
                              <th width="5%" style={{ textAlign: "center" }}>
                                highlight pic 2
                              </th>
                              <th width="15%" style={{ textAlign: "center" }}>
                                จัดการ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {researcherData.map((row, idx) =>
                              <tr key={idx}>
                                <td style={{ textAlign: "center" }}>
                                  {idx + 1}
                                </td>
                                <td>
                                  {row.name}
                                </td>
                                <td>
                                  {getUnitByTabAndIndex(activeTab, idx)}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <img
                                    src={`${xURL}file_research/${row.picname}`}
                                    alt="profile"
                                    className="table-img"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      setEnlargedImage(
                                        `${xURL}file_research/${row.picname}`
                                      )}
                                  />
                                </td>
                                <td>
                                  <div style={{ lineHeight: "1.6" }}>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        color: "#1a1a1a",
                                        marginBottom: "5px"
                                      }}
                                    >
                                      {row.topic_name_th}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "13px",
                                        color: "#666",
                                        fontStyle: "italic"
                                      }}
                                    >
                                      {row.topic_name_eng}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {row.topic_pic1
                                    ? <img
                                        src={`${xURL}file_research_topic/${row.topic_pic1}`}
                                        alt="img1"
                                        className="table-img"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          setEnlargedImage(
                                            `${xURL}file_research_topic/${row.topic_pic1}`
                                          )}
                                      />
                                    : <div
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          backgroundColor: "#f0f0f0",
                                          borderRadius: "4px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: "#999",
                                          fontSize: "20px"
                                        }}
                                      >
                                        📷
                                      </div>}
                                </td>

                                <td style={{ textAlign: "center" }}>
                                  {row.topic_pic2
                                    ? <img
                                        src={`${xURL}file_research_topic/${row.topic_pic2}`}
                                        alt="img2"
                                        className="table-img"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          setEnlargedImage(
                                            `${xURL}file_research_topic/${row.topic_pic2}`
                                          )}
                                      />
                                    : <div
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          backgroundColor: "#f0f0f0",
                                          borderRadius: "4px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          color: "#999",
                                          fontSize: "20px"
                                        }}
                                      >
                                        📷
                                      </div>}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <button
                                    className="action-btn"
                                    onClick={() => handleEditClick(row)}
                                  >
                                    แก้ไข
                                  </button>
                                  {/* <button className="action-btn delete">
                                    ลบ
                                  </button> */}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>}
              </div>}
          </div>
        </div>
      </div>
      {isEditModalOpen &&
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
            style={{
              maxHeight: "90vh",
              overflowY: "auto",
              overflowX: "hidden"
            }}
          >
            <h3
              style={{
                position: "sticky",
                top: "-28px",
                backgroundColor: "#aad0f0",
                color: "#000",
                padding: "15px",
                margin: "-30px -30px 50px -30px",
                borderRadius: "8px 8px 0 0",
                fontSize: "18px",
                fontWeight: "600",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                zIndex: 100
              }}
            >
              ✏️ แก้ไขข้อมูลวิจัยที่โดดเด่น
            </h3>

            <div className="form-group">
              <label>หัวข้อวิจัย (ไทย)</label>
              <input
                type="text"
                value={editFormData.topic_name_th}
                onChange={e =>
                  setEditFormData({
                    ...editFormData,
                    topic_name_th: e.target.value
                  })}
              />
            </div>

            <div className="form-group">
              <label>หัวข้อวิจัย (อังกฤษ)</label>
              <input
                type="text"
                value={editFormData.topic_name_eng}
                onChange={e =>
                  setEditFormData({
                    ...editFormData,
                    topic_name_eng: e.target.value
                  })}
              />
            </div>

            {/* เพิ่มฟิลด์รายละเอียด (ไทย) */}
            <div className="form-group">
              <label>รายละเอียด (ไทย)</label>
              <textarea
                value={editFormData.topic_detail_th}
                onChange={e =>
                  setEditFormData({
                    ...editFormData,
                    topic_detail_th: e.target.value
                  })}
                rows="4"
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontFamily: "Arial, sans-serif",
                  resize: "vertical"
                }}
              />
            </div>

            {/* เพิ่มฟิลด์รายละเอียด (อังกฤษ) */}
            <div className="form-group">
              <label>รายละเอียด (อังกฤษ)</label>
              <textarea
                value={editFormData.topic_detail_eng}
                onChange={e =>
                  setEditFormData({
                    ...editFormData,
                    topic_detail_eng: e.target.value
                  })}
                rows="4"
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontFamily: "Arial, sans-serif",
                  resize: "vertical"
                }}
              />
            </div>

            <div className="form-group">
              <label>รูป 1</label>
              <div className="file-input-wrapper">
                {/* แสดงรูปเก่า */}
                {editFormData.topic_pic1_old &&
                  !editFormData.topic_pic1_preview &&
                  <div className="preview">
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: "10px"
                      }}
                    >
                      รูปเก่า:
                    </p>
                    <img
                      src={`${xURL}file_research_topic/${editFormData.topic_pic1_old}`}
                      alt="current 1"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>}
                {/* แสดง preview รูปใหม่ */}
                {editFormData.topic_pic1_preview &&
                  <div className="preview">
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: "10px"
                      }}
                    >
                      รูปใหม่:
                    </p>
                    <img
                      src={editFormData.topic_pic1_preview}
                      alt="preview 1"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>}
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => handleFileChange(e, "topic_pic1")}
                />
              </div>
            </div>

            <div className="form-group">
              <label>รูป 2</label>
              <div className="file-input-wrapper">
                {/* แสดงรูปเก่า */}
                {editFormData.topic_pic2_old &&
                  !editFormData.topic_pic2_preview &&
                  <div className="preview">
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: "10px"
                      }}
                    >
                      รูปเก่า:
                    </p>
                    <img
                      src={`${xURL}file_research_topic/${editFormData.topic_pic2_old}`}
                      alt="current 2"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>}
                {/* แสดง preview รูปใหม่ */}
                {editFormData.topic_pic2_preview &&
                  <div className="preview">
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginBottom: "10px"
                      }}
                    >
                      รูปใหม่:
                    </p>
                    <img
                      src={editFormData.topic_pic2_preview}
                      alt="preview 2"
                      style={{ maxWidth: "150px" }}
                    />
                  </div>}
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => handleFileChange(e, "topic_pic2")}
                />
              </div>
            </div>

            <div className="modal-buttons">
              <button onClick={handleSaveEdit} className="btn-save">
                บันทึก
              </button>
              <button onClick={handleCloseModal} className="btn-cancel">
                ยกเลิก
              </button>
            </div>
          </div>
        </div>}

      {enlargedImage &&
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            cursor: "pointer"
          }}
          onClick={() => setEnlargedImage(null)}
        >
          <div
            style={{
              maxWidth: "80vw",
              maxHeight: "80vh",
              position: "relative",
              animation: "fadeIn 0.3s ease-in"
            }}
            onClick={e => e.stopPropagation()}
          >
            <img
              src={enlargedImage}
              alt="enlarged"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)"
              }}
            />
            <button
              onClick={() => setEnlargedImage(null)}
              style={{
                position: "absolute",
                top: "-40px",
                right: "0",
                background: "white",
                border: "none",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                fontSize: "24px",
                cursor: "pointer",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              ✕
            </button>
          </div>
        </div>}
    </div>
  );
};

export default Research_highlight_from;
